import React, { Component } from 'react';
import { images } from '../../../../settings';
import { BrowserRouter as Router, Link } from 'react-router-dom';

import './Autoregulacao.scoped.scss';

class Autoregulacao extends Component {
  constructor(props) {
    super(props);
    this.images = images;
  }
  render() {
    return (
      <div className="planos-template autoregulacao">
        <div className="planos-template--risca" style={{ backgroundColor: this.props.cor }}></div>
        <div className="planos-template__conteudo">
          {/* <h3 className="h2 h2--500 planos-template__titulo" style={{ color: this.props.cor }}>
            Liquidez
          </h3> */}
          <h4 className="planos-template__subtitulo">
            As iniciativas relacionadas à autorregulação se deram em cinco frentes:
          </h4>
          <div className="planos-template__linha">
            <div className="autoregulacao planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_autoregulacao1} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">
                  Modernizar e buscar eficiência nos processos de supervisão
                </h5>
                <p>
                  Avançamos na implantação do projeto ANBIMA Supervisão Digital, com novas tecnologias para o
                  monitoramento das instituições que fazem parte da Associação: 27 processos foram automatizados com o
                  uso de robôs e passamos a usar inteligência artificial também para registro e alteração do cadastro de
                  fundos de investimento. Iniciamos também as análises para o enquadramento de fundos em sistema
                  específico e o uso de testes com formulário inteligente para registro de ofertas públicas.
                </p>
              </div>
            </div>
          </div>

          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_autoregulacao2} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">
                  Revisar o Código de Processos e eventuais desdobramentos nos demais códigos de autorregulação
                </h5>
                <p>
                  O Código de Processos foi revisado e passará por audiência pública no primeiro semestre de 2021, com
                  previsão de entrar em vigor no mesmo ano.
                </p>
              </div>
            </div>
          </div>

          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_autoregulacao3} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">
                  Mapear como os reguladores nacionais e internacionais (inclusive de outros setores) registram críticas
                  e denúncias
                </h5>
                <p>Apresentamos o mapeamento ao Comitê Executivo da ANBIMA e o projeto foi finalizado.</p>
              </div>
            </div>
          </div>

          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_autoregulacao4} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">
                  Aprofundar a troca de informações e estudar a viabilidade de novos convênios com o órgão regulador
                  para outros temas além dos existentes
                </h5>
                <p>Iniciadas conversas com a CVM sobre temas em comum que podem ser alvos de futuros convênios.</p>
              </div>
            </div>
          </div>

          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_autoregulacao5} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">
                  Fortalecer a autorregulação por meio dos processos de supervisão
                </h5>
                <p>
                  Com a diversificação dos produtos de investimento – em função da baixa taxa de juros –, identificamos
                  a necessidade de aumentar os esforços de supervisão na distribuição. Foi aprovado e iniciado um plano
                  de trabalho para reforçar o monitoramento dessa atividade.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="planos-template__footer">
          <a
            className="button button--aylen button--green button--border-medium button--size-m button--round-l button--text-thick"
            href="https://www.anbima.com.br/data/files/B5/B5/1F/15/375FE610DC784BE6192BA2A8/Relatorio_de_Iniciativas_2019.pdf "
            target="_blank"
          >
            Saiba mais no Relatório de Iniciativas
          </a>
        </div> */}
      </div>
    );
  }
}
export { Autoregulacao };
